<template>
  <v-dialog width="unset" persistent v-model="visibleModel" @keydown.esc="close(false)">
    <v-card>
      <v-card-title>
        筛选索评记录
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-container fluid>
            <v-select v-model="filters.status" :items="statuses" label="索评状态"/>
            <v-text-field v-model="filters.amazonOrderId" label="亚马逊订单编号" clearable/>
            <v-row>
              <v-col>
                <v-text-field v-model="filters.startPurchaseTime" label="订单开始日期" type="datetime-local" clearable/>
              </v-col>
              <v-col>
                <v-text-field v-model="filters.endPurchaseTime" label="订单结束日期" type="datetime-local" clearable/>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field v-model="filters.startRequestTime" label="索评开始日期" type="datetime-local" clearable/>
              </v-col>
              <v-col>
                <v-text-field v-model="filters.endRequestTime" label="索评结束日期" type="datetime-local" clearable/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="warning" @click="reset">重置</v-btn>
        <v-spacer/>
        <v-btn text color="grey" @click="close(false)">关闭</v-btn>
        <v-btn text color="primary" @click="save">保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RequestFilterDialog",
  model: {
    prop: "visible",
    event: "update"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    filters: Object
  },
  computed: {
    visibleModel: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  },
  data() {
    return {
      loading: true,
      statuses: [
        {
          text: "成功",
          value: 1
        },
        {
          text: "已索评",
          value: 2
        },
        {
          text: "已退款",
          value: 3
        },
        {
          text: "时辰未到",
          value: 0
        },
        {
          text: "反复索评",
          value: 4
        },
        {
          text: "未知状态",
          value: -1
        },
      ]
    }
  },
  methods: {
    save() {
      this.close(true)
    },
    close(flag) {
      this.visibleModel = false

      if (flag) {
        this.$emit('reload')
      }
    },
    reset() {
      this.filters.status = null
      this.filters.amazonOrderId = null
      this.filters.startPurchaseTime = null
      this.filters.endPurchaseTime = null
      this.filters.startRequestTime = null
      this.filters.endRequestTime = null
    }
  }
}
</script>

<style scoped>

</style>